<template>
  <section v-if="canShow">
    <div class="container-xl">
      <div class="filter-visual" v-for="(filters, index) in currentFilter" :key="index">
        <div class="filter-visual-subheader">
          <h4>Produktfilter</h4>
        </div>
        <div class="filter-visual-header">
          <h2><span v-if="visualFilters.length > 1">{{ currentStep + 1 }}. </span>{{ filters.description || filters.label }}</h2>
          <div class="filter-visual-header-nav" v-if="visualFilters.length > 1">
            <a class="btn btn-xs btn-arrow arrow-left-dark" @click="prev()" :class="{ active: canPrev }" />
            <a class="btn btn-xs btn-arrow arrow-right-dark" @click="next()" :class="{ active: canNext }" />
          </div>
        </div>

        <div class="filter-visual-content">
          <a
            :class="{ 'filter-visual-item': true, 'filter-visual-item-active': isFilterActive(filter)}"
            v-for="filter in filters.options"
            :key="filter.id"
            @click="changeFilter(filter)"
          >
            <div class="filter-visual-item-content">
              <div class="filter-visual-item-image">
                <SfImage :src="getThumbnailPath(filter.image)" />
              </div>
              <div class="filter-visual-item-title">
                {{ filter.label }}
              </div>
            </div>
          </a>
        </div>
      </div>

      <div class="filter-progress" v-if="visualFilters.length > 1">
        <div class="filter-progress-bar-wrapper">
          <div class="filter-progress-bar">
            <div
              v-for="(filters, index) in visualFilters"
              :class="{'filter-progress-bar-item': true, 'filter-progress-bar-item-active': currentStep === index }"
              :key="index"
            >
              <span>{{ index + 1 }}</span>
              <div class="filter-progress-bar-item-title">
                {{ filters.label }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr class="divider">
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { SfButton, SfImage } from '@storefront-ui/vue';
import { getThumbnailPath } from '@vue-storefront/core/helpers'
import castArray from 'lodash-es/castArray';

export default {
  name: 'OVisualFilter',
  data () {
    return {
      currentStep: 0
    }
  },
  props: {
    availableFilters: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    SfButton,
    SfImage
  },
  computed: {
    ...mapGetters({
      getAttributeListByCode: 'attribute/getAttributeListByCode',
      getCurrentFilters: 'category-next/getCurrentFilters'
    }),
    visualFilters () {
      var visualFilters = []
      for (const [filterName, filter] of Object.entries(this.availableFilters)) {
        let attribute = this.getAttributeListByCode[filterName]
        if (!attribute) {
          continue
        }

        let filterOptions = filter.map((option) => {
          let attributeOption = attribute.options?.find((opt) => opt.value === option.id)
          if (attributeOption?.swatch?.value) {
            option.image = attributeOption.swatch.value
            option.sort_order = attributeOption.sort_order
            return option
          }
        }).filter(option => typeof option !== 'undefined')
          .sort((a, b) => a.sort_order - b.sort_order)

        if (filterOptions.filter((option) => option).length === 0) {
          continue
        }

        visualFilters.push({
          label: attribute.frontend_label,
          description: attribute.description,
          options: filterOptions
        })
      }

      return visualFilters
    },
    currentFilter () {
      return this.visualFilters.filter((option, index) => {
        return index === this.currentStep
      })
    },
    isFilterActive () {
      return filter =>
        castArray(this.getCurrentFilters[filter.type]).find(
          variant => variant && variant.id === filter.id
        ) !== undefined;
    },
    canNext () {
      return this.currentStep < Object.entries(this.visualFilters).length - 1
    },
    canPrev () {
      return this.currentStep > 0
    },
    canShow () {
      return this.currentFilter && this.currentFilter.length > 0
    }
  },
  methods: {
    changeFilter (filter) {
      if (filter) {
        this.$store.dispatch('category-next/switchSearchFilters', [filter]);
      }
    },
    next () {
      if (this.canNext) {
        this.currentStep++
      }
    },
    prev () {
      if (this.canPrev) {
        this.currentStep--
      }
    },
    getThumbnailPath (image) {
      return getThumbnailPath(image, 200, 200, 'swatch');
    }
  }
}
</script>
